/*
 * File: auth.interceptor.ts
 * Project: rast-app
 * Create Date: Tuesday, 5th August 2025
 * Author: Pedro Santos (pedro.santos@vonbraunlabs.com)
 * -----
 * Last Modified: Tuesday, 5th August 2025 9:17:20 pm
 * Modified by: Pedro Santos (pedro.santos@vonbraunlabs.com)
 * -----
 * Copyright (c) 2025 CPA Wernher von Braun
 * ----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	---------------------------------------------------------
 */

import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../services/authentication/authentication.service';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const authenticationService = inject(AuthenticationService);

  if (authenticationService.isUserLoggedIn() && req.url.startsWith(`${environment.apiUrl}`)) {
    const authReq = req.clone({ setHeaders: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } });

    return next(authReq);
  }

  return next(req);
}
